// extracted by mini-css-extract-plugin
export default {"img":"YXYwIJEE2oMJjguowDoJ"};